export default "__VITE_ASSET__CwolA9Q6__"